/**
 * created by xcc on 2022/5/31
 * 微博接口
 */

import request from "../../../base/request";

let host = "/cm-sites-pms/weibo/";

const Apis = {
    getMediaById: "/cm-sites-pms/media/getById", //获取媒体
    getCounts: host + "getCounts", //批量获取指定微博的转发数评论数喜欢数
    getUserInfo: host + "getUserInfo", //获取当前登录用户的信息
    getMicroBlogData: host + 'isOAuth', //是否认证
    getGoProveData: host + 'gotoOAuth', //去验证
    getIfProveSuccessData: host + 'isOAuthSuccess', //检查是否验证成功
    getAllEmotionsList: host + 'getEmotions', //获取表情
    getRepostListById: host + 'repostListById', //获取微博分享列表
    getLikeListById: host + 'likeListById', //获取点赞列表
    getCommentsByWeiboId: host + 'getCommentsByWeiboId', //获取评论列表
    createComment: host + 'createComment',//微博评论
    replyComment: host + 'replyComment', //回复评论
    delComment: host + 'delComment',//删除评论
    getWeiboByWeiboId: host + 'getById',// 查看详情
    saveWeibo: host + 'save',//保存
    saveStatusName: host + 'saveStatusName',//更新微博的状态
    deleteWeibo: host + 'delete',//删除一条本地自己发的微博
    getRevokeWeibo: host + 'undo',//撤稿一条微博
    updateProcessData: '/cm-sites-sys/process/revert',//更新流程状态数据
    publishWeibo: host + 'publish',//发布
    getButtonByMediaCode: '/cm-sites-pms/mediaTreeActiviti/getMediaRoleByColum',//
    searchUser: host + 'seachUser',//获取@列表
    hotTopic: host + 'hotTopic',//话题
    location: host + 'location',//地图查询
    getWeiboMessageList: host + 'getWeiboMessageList',//微博私信功能开发
    getWeiboMessageDetail: host + 'getWeiboMessageDetail',//微博消息详情
    replyMsg: host + 'replyMsg',//微博私信回复
    getTodoListList: '/cm-sites-sys/process/getTodoList',//待我处理
}

export const getTodoListList = (body, callBack) => {
    request({url: Apis.getTodoListList, contentType: "json", method: "post", body, callBack});
};

export const getMediaById = (body, callBack) => {
    request({url: Apis.getMediaById, body, callBack});
};
export const getWeiboListByType = (body, callBack, type) => {
    let url = "";
    if(type === "all"){
        url =  host + "pageList"; //全部
    }else if(type === "drafts"){
        url =  host + "draft"; //草稿
    }else if(type === "auditing"){
        url =  host + "audit"; //审核中
    }else if(type === "release"){
        url =  host + "publishList"; //已发布
    }else if(type === "abandon"){
        url =  host + "withdraw"; //已撤稿
    }
    request({url, body, callBack});
};
export const getCounts = (body, callBack) => {
    request({url: Apis.getCounts, contentType: "json", method: "post", body, callBack});
};
export const getUserInfo = (body, callBack, message) => {
    request({url: Apis.getUserInfo, body, callBack, message});
};
export const getMicroBlogData = (body, callBack) => {
    request({url: Apis.getMicroBlogData, body, callBack});
};
export const getGoProveData = (body, callBack) => {
    request({url: Apis.getGoProveData, body, callBack});
};
export const getIfProveSuccessData = (body, callBack) => {
    request({url: Apis.getIfProveSuccessData, body, callBack});
};
export const getAllEmotionsList = (body, callBack) => {
    request({url: Apis.getAllEmotionsList, body, callBack});
};
export const getRepostListById = (body, callBack) => {
    request({url: Apis.getRepostListById, body, callBack});
};
export const getLikeListById = (body, callBack) => {
    request({url: Apis.getLikeListById, body, callBack});
};
export const getCommentsByWeiboId = (body, callBack) => {
    request({url: Apis.getCommentsByWeiboId, body, callBack});
};
export const createComment = (body, callBack) => {
    request({url: Apis.createComment, method: "post", body, callBack});
}
export const replyComment = (body, callBack) => {
    request({url: Apis.replyComment, method: "post", body, callBack});
}
export const delComment = (body, callBack) => {
    request({url: Apis.delComment, method: "post", body, callBack});
}
export const getWeiboByWeiboId = (body, callBack) => {
    request({url: Apis.getWeiboByWeiboId, body, callBack});
}
export const saveWeibo = (body, callBack) => {
    request({url: Apis.saveWeibo, contentType: "json", method: "post", body, callBack});
}
export const saveStatusName = (body, callBack) => {
    request({url: Apis.saveStatusName, method: "post", body, callBack});
}
export const deleteWeibo = (body, callBack) => {
    request({url: Apis.deleteWeibo, method: "post", body, callBack});
}
export const getRevokeWeibo = (body, callBack) => {
    request({url: Apis.getRevokeWeibo, method: "post", body, callBack});
}
export const updateProcessData = (body, callBack) => {
    request({url: Apis.updateProcessData, contentType: "json", method: "post", body, callBack});
}
export const publishWeibo = (body, callBack) => {
    request({url: Apis.publishWeibo, contentType: "json", method: "post", body, callBack});
}
export const getButtonByMediaCode = (body, callBack) => {
    request({url: Apis.getButtonByMediaCode, contentType: "json", method: "post", body, callBack});
}
export const searchUser = (body, callBack) => {
    request({url: Apis.seachUser, body, callBack});
}
export const hotTopic = (body, callBack) => {
    request({url: Apis.hotTopic, body, callBack});
}
export const location = (body, callBack) => {
    request({url: Apis.location, body, callBack});
}
export const getWeiboMessageList = (body, callBack) => {
    request({url: Apis.getWeiboMessageList, body, callBack});
}
export const getWeiboMessageDetail = (body, callBack) => {
    request({url: Apis.getWeiboMessageDetail, body, callBack});
}
export const replyMsg = (body, callBack) => {
    request({url: Apis.replyMsg, body, callBack});
}